export default "__VITE_ASSET__ff018f4f__"